"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearStatus = exports.clear = exports.toggleModal = exports.unsetApiIdentifierFailure = exports.unsetApiIdentifierSuccess = exports.unsetApiIdentifierRequest = exports.setApiIdentifierFailure = exports.setApiIdentifierSuccess = exports.setApiIdentifierRequest = void 0;
const ActionTypes = require("../../actionTypes/bid/reliablePartnerSettings");
const setApiIdentifierRequest = (payload) => ({
    type: ActionTypes.SET_API_IDENTIFIER_REQUEST,
    payload
});
exports.setApiIdentifierRequest = setApiIdentifierRequest;
const setApiIdentifierSuccess = () => ({
    type: ActionTypes.SET_API_IDENTIFIER_REQUEST_SUCCESS
});
exports.setApiIdentifierSuccess = setApiIdentifierSuccess;
const setApiIdentifierFailure = (payload) => ({
    type: ActionTypes.SET_API_IDENTIFIER_REQUEST_FAILURE,
    payload
});
exports.setApiIdentifierFailure = setApiIdentifierFailure;
const unsetApiIdentifierRequest = (payload) => ({
    type: ActionTypes.UNSET_API_IDENTIFIER_REQUEST,
    payload
});
exports.unsetApiIdentifierRequest = unsetApiIdentifierRequest;
const unsetApiIdentifierSuccess = () => ({
    type: ActionTypes.UNSET_API_IDENTIFIER_REQUEST_SUCCESS
});
exports.unsetApiIdentifierSuccess = unsetApiIdentifierSuccess;
const unsetApiIdentifierFailure = (payload) => ({
    type: ActionTypes.UNSET_API_IDENTIFIER_REQUEST_FAILURE,
    payload
});
exports.unsetApiIdentifierFailure = unsetApiIdentifierFailure;
const toggleModal = () => ({
    type: ActionTypes.TOGGLE_MODAL
});
exports.toggleModal = toggleModal;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
const clearStatus = () => ({
    type: ActionTypes.CLEAR_STATUS
});
exports.clearStatus = clearStatus;
//# sourceMappingURL=reliablePartnerSettings.js.map